import { IAddress } from 'app/shared/model/address.model';
import { IBankAccount } from 'app/shared/model/bank-account.model';
import { IContact } from 'app/shared/model/contact.model';

export interface ICustomerAccount {
  id?: number;
  isContact?: boolean | null;
  collectiveInvoice?: boolean | null;
  billingAddress?: IAddress | null;
  bankAccount?: IBankAccount | null;
  contractHolder?: IContact | null;
}

export const defaultValue: Readonly<ICustomerAccount> = {
  isContact: false,
  collectiveInvoice: false,
};
